import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import { getClientList } from '../../../services/admin/api';
import './client-list.css';

const ClientList = ({ searchTerm }) => {
  const [clients, setClients] = useState([]);
  const [sortColumn, setSortColumn] = useState('username');
  const [sortOrder, setSortOrder] = useState('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const result = await getClientList();
        //console.log("Fetched clients:", result);
        if (Array.isArray(result)) {
          setClients(result);
        } else {
          console.error('Expected array of clients, got:', result);
        }
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };

    fetchClients();
  }, []);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };

  const filteredClients = useMemo(() => {
    return clients
      .filter((client) =>
        client.username?.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .sort((a, b) => {
        if (a[sortColumn] < b[sortColumn]) return sortOrder === 'asc' ? -1 : 1;
        if (a[sortColumn] > b[sortColumn]) return sortOrder === 'asc' ? 1 : -1;
        return 0;
      });
  }, [searchTerm, sortColumn, sortOrder, clients]);

  const paginatedClients = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filteredClients.slice(start, start + itemsPerPage);
  }, [filteredClients, currentPage]);

  const totalPages = Math.ceil(filteredClients.length / itemsPerPage);

  const goToPage = (page) => {
    setCurrentPage(page);
  };

    const handleNavigateToCandidates = (client) => {
      navigate(`/admin/client/${client.email}/candidates`, {
        state: {
          heading: 'Candidates List',
          clientUserId: client.id,
          clientName:client.username,
          companyName: client.companyname,
        }
      });
    };


  return (
    <div className="table-wrapper">
      <table className="client-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('username')}>Client Name</th>
            <th onClick={() => handleSort('companyname')}>Company</th>
            <th onClick={() => handleSort('email')}>Email</th>
            <th onClick={() => handleSort('phonenumber')}>Contact Number</th>
            <th>Candidates</th>
          </tr>
        </thead>
        <tbody>
          {paginatedClients.map((client, index) => (
            <tr key={index}>
              <td>{client.username}</td>
              <td>{client.companyname}</td>
              <td>{client.email}</td>
              <td>{client.phonenumber}</td>
              <td>
                <button
                  className="candidate-btn"
                  onClick={() => handleNavigateToCandidates(client)}
                >
                  <Users size={18} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination-bottom pagination-controls">
        <button
          onClick={() => goToPage(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        >
          Prev
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => goToPage(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ClientList;
